import { useMemo } from "react"
import { IntlShape } from "react-intl"
import { EViewerDirection } from "../../enums/animationSettings"
import { message } from "../../messages/animationSettings"

export default function useSpinDirectionSelection(intl: IntlShape) {
    return useMemo(
        () => [
            {
                label: intl.formatMessage(message.clockwise),
                value: EViewerDirection.Clockwise,
            },
            {
                label: intl.formatMessage(message.counterClockwise),
                value: EViewerDirection.CounterClockwise,
            },
        ],
        [intl],
    )
}
